import React from "react";
import { OnboardingData } from "../../../types";

interface OnboardingExpectationsProps {
  onboarding: OnboardingData;
  onEdit?: () => void;
}

export const OnboardingExpectations: React.FC<OnboardingExpectationsProps> = ({
  onboarding,
}) => {
  return (
    <div className="flex w-full flex-col items-start gap-4 rounded-md border border-solid border-neutral-border bg-default-background px-4 py-4 shadow-sm">
      <div className="flex items-center gap-4 pl-0 md:pl-3">
        <span className="text-subheader font-subheader text-default-font">
          Onboarding expectations
        </span>
        {/* {onEdit && (
          <button
            onClick={onEdit}
            className="flex items-center gap-1 hover:opacity-80 transition-opacity"
          >
            <span className="text-label font-label text-brand-primary underline">
              Edit
            </span>
            <SubframeCore.Icon
              className="text-body font-body text-brand-primary"
              name="FeatherEdit"
            />
          </button>
        )} */}
      </div>
      <div className="flex w-full flex-col items-start gap-4 pl-0 md:pl-3">
        <div className="flex w-full flex-col items-start">
          <span className="w-full break-words text-body font-body text-neutral-500">
            Preferred shifts
          </span>
          <span className="w-full break-words text-body font-body text-default-font">
            {onboarding.preferredShifts}
          </span>
        </div>
        <div className="flex w-full flex-col items-start">
          <span className="w-full break-words text-body font-body text-neutral-500">
            Weekly hours desired
          </span>
          <span className="w-full break-words text-body font-body text-default-font">
            {onboarding.weeklyHours}
          </span>
        </div>
        <div className="flex w-full flex-col items-start">
          <span className="w-full break-words text-body font-body text-neutral-500">
            Career Goal
          </span>
          <span className="w-full break-words text-body font-body text-default-font">
            {onboarding.careerGoal}
          </span>
        </div>
        <div className="flex w-full flex-col items-start">
          <span className="w-full break-words text-body font-body text-neutral-500">
            Driving expectations
          </span>
          <span className="w-full break-words text-body font-body text-default-font">
            {onboarding.drivingExpectations}
          </span>
        </div>
        <div className="flex w-full flex-col items-start">
          <span className="w-full break-words text-body font-body text-neutral-500">
            Patients preference
          </span>
          <span className="w-full break-words text-body font-body text-default-font">
            {onboarding.patientsPreference}
          </span>
        </div>
      </div>
    </div>
  );
}; 